/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const setItemFinancialsRequestSchema = z.object({
  budgetAmount: z.number().nullish(),
  capexPercentage: z.number().nullish(),
  forecastRevenueAmount: z.number().nullish(),
});
